import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(30 * 60); // 30 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <motion.div initial={{
    y: -50
  }} animate={{
    y: 0
  }} transition={{
    delay: 0.5,
    type: 'spring',
    stiffness: 100
  }} className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-yellow-500/30 shadow-[0_4px_20px_rgba(234,179,8,0.15)]" data-id="element-253">
      <div className="max-w-7xl mx-auto px-4 h-12 flex items-center justify-between text-sm md:text-base" data-id="element-254">
        <div className="flex items-center gap-2" data-id="element-255">
          <span className="w-2.5 h-2.5 rounded-full bg-red-500 animate-ping absolute opacity-75" data-id="element-256"></span>
          <span className="w-2.5 h-2.5 rounded-full bg-red-500 relative" data-id="element-257"></span>
          <span className="font-bold text-white tracking-wide" data-id="element-258">
            OFERTA LIMITADA
          </span>
        </div>

        <div className="flex items-center gap-2" data-id="element-259">
          <span className="hidden md:inline text-gray-400" data-id="element-260">Termina en:</span>
          <div className="font-mono font-bold bg-zinc-900 border border-yellow-500/30 px-3 py-1 rounded text-yellow-500" data-id="element-261">
            {formatTime(timeLeft)}
          </div>
        </div>
      </div>
    </motion.div>;
}